export default __webpack_public_path__ + "static/bocuse_image-49d2fec5ad64266f0024441cc8db807a.jpg";